import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function NumLoanRequestsAnsweredBetween({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getNumLoanRequestsAnswered(query);
  const value =
    options.find((option) => !areObjectsDifferent(option.value, state)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setNumLoanRequestsAnswered(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Number of loan requests answered"
      description="Filter applications by how many loan requests have been answered"
      disabled={!editable}
    />
  );
}

const options: {
  label: string;
  value: Value;
}[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: '0-2 requests',
    value: { To: 3 },
  },
  {
    label: '2+ requests',
    value: { From: 2 },
  },
  {
    label: '3+ requests',
    value: { From: 3 },
  },
];

function setNumLoanRequestsAnswered(
  range: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryNumAnsweredLoanRequests: range,
  });
}

function getNumLoanRequestsAnswered(query: ace_index.FindInput) {
  return query.SummaryNumAnsweredLoanRequests;
}

type Value = ace_index.FindInput['SummaryNumAnsweredLoanRequests'];
